import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { navLinks, contactInfo } from '../data/mock';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    setIsMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('#home');
            }}
            className="flex items-center gap-2 group"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/xpwy37pu_TTPOOLS.png" 
              alt="TT Pools Logo"
              className="h-14 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className={`text-sm font-medium transition-colors duration-300 hover:text-cyan-500 ${
                  isScrolled ? 'text-slate-600' : 'text-white/90'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button & Mobile Menu */}
          <div className="flex items-center gap-4">
            <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="hidden sm:flex items-center gap-2">
              <Phone className={`w-4 h-4 ${isScrolled ? 'text-cyan-600' : 'text-cyan-300'}`} />
              <span className={`text-sm font-medium ${isScrolled ? 'text-slate-700' : 'text-white'}`}>
                {contactInfo.phone}
              </span>
            </a>
            <Button
              onClick={() => scrollToSection('#contact')}
              className="hidden md:flex bg-cyan-500 hover:bg-cyan-600 text-white shadow-lg hover:shadow-cyan-500/30 transition-all duration-300"
            >
              Request a Quote
            </Button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`md:hidden p-2 rounded-lg transition-colors ${
                isScrolled ? 'text-slate-700 hover:bg-slate-100' : 'text-white hover:bg-white/10'
              }`}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMenuOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
        >
          <nav className="flex flex-col gap-4 pt-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className={`text-base font-medium transition-colors ${
                  isScrolled ? 'text-slate-700 hover:text-cyan-600' : 'text-white hover:text-cyan-300'
                }`}
              >
                {link.label}
              </a>
            ))}
            <Button
              onClick={() => scrollToSection('#contact')}
              className="mt-2 bg-cyan-500 hover:bg-cyan-600 text-white w-full"
            >
              Request a Quote
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
